import { moveMediaElementZindexUpAction } from 'editor/src/store/design/slice';
import { ElementAddress } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';

const moveMediaElementZindexUpOperation = (elementAddress: ElementAddress) => (dispatch: ThunkDispatch) =>
  dispatch(moveMediaElementZindexUpAction(elementAddress));

export default moveMediaElementZindexUpOperation;
